import { OrgCreateInput } from "../../schema/types/org/create";

export function getDefaultOrgCreateInput(): OrgCreateInput {
  return {
    accountId: "",
    description: "",
    invitees: [],
    name: "",
    meta: {
      users: [],
    },
  };
}
